export default __webpack_public_path__ + "static/media/clock.5167ad95.svg";